/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationSource } from './EvaluationSource';
import {
    EvaluationSourceFromJSON,
    EvaluationSourceFromJSONTyped,
    EvaluationSourceToJSON,
} from './EvaluationSource';

/**
 * 
 * @export
 * @interface EvaluationMetricsRequest
 */
export interface EvaluationMetricsRequest {
    /**
     * Selection of 1 through 100 sources, possibly from several projects
     * @type {Array<EvaluationSource>}
     * @memberof EvaluationMetricsRequest
     */
    sources: Array<EvaluationSource>;
}

/**
 * Check if a given object implements the EvaluationMetricsRequest interface.
 */
export function instanceOfEvaluationMetricsRequest(value: object): value is EvaluationMetricsRequest {
    if (!('sources' in value) || value['sources'] === undefined) return false;
    return true;
}

export function EvaluationMetricsRequestFromJSON(json: any): EvaluationMetricsRequest {
    return EvaluationMetricsRequestFromJSONTyped(json, false);
}

export function EvaluationMetricsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationMetricsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sources': ((json['sources'] as Array<any>).map(EvaluationSourceFromJSON)),
    };
}

export function EvaluationMetricsRequestToJSON(value?: EvaluationMetricsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sources': ((value['sources'] as Array<any>).map(EvaluationSourceToJSON)),
    };
}

